<template>
  <div class="pd-embed-control" style="width:100%;height:100%;position:relative;">
    <div class="flex-wrap value-wrap" style="padding:0 5px;cursor:pointer;background:#fff;font-size:14px;" :style="{color:value?'var(--primary)':''}"  @click="open">
      {{value?'编辑表式' : '创建表式'}}
    </div>
    <div class="flex-wrap flex-center" style="position:absolute;right:0;top:0;bottom:0;width:30px;color:#aaa;" @click="$emit('input',null)" v-if="value">
      <Icon type="md-trash" size="16" />
    </div>

    <Modal class-name="ugo-modal" v-model="modalSelector" width="1400" title="表单设计器" footer-hide >
      <template v-if="modalSelector">
        <BaseWinMenu style="background:#eee;border-bottom:1px solid var(--border);color:#333" :items="menus" :active="formView" @event="handleEvent">


        </BaseWinMenu>
        <div>
          <keep-alive>
            <template v-if="formView=='editor'">
              <FormEditor ref="editor" v-model="form" />
            </template>
             <template v-else-if="formView=='test'">
              <FormTest :form="form" />
            </template>
            <!-- <template v-else-if="formView=='flow'">
              <flow-editor :form="form" :flow="flow" />
            </template> -->
            <template v-else-if="formView=='print'">
              <FormPrint :form="form" />
            </template>
             <template v-else-if="formView=='view'">
             <FormHtml :form="form" />
            </template>
             <template v-else-if="formView=='config'">
               <FormOption :form="form" />
            </template>
         </keep-alive>
          </div>
        </template>
    </Modal>
  </div>
</template>

<script>
import FormEditor from '@/components/form/editor';
import FormTest from '@/components/form/test';
// import FlowEditor from '@/components/flow/editor'
import FormHtml from '@/components/form/html';
import FormOption from '@/components/form/option';
import FormPrint from '@/components/form/print';
// import Explorer from '@/components/explorer'
import {cloneDeep} from 'lodash';
export default {
  data() {
    return {
      loadingList: false,
      items: [],
      form: {id: 'create',
        name: '新建表单',
        fields: []},
      flow: {nodes: [], edges: []},
      formView: 'editor',
      modalSelector: false,
    };
  },
  components: {
    FormEditor, FormTest, FormHtml, FormOption, FormPrint,
  },
  props: {
    value: {
      type: Object,
      default: ()=>({}),
    },
    option: {
      type: Object,
      default: ()=>({}),
    },
  },
  computed: {
    menus() {
      const items = [{
        icon: 'edit',
        name: '表单设计',
        key: 'editor',
      },
      // {
      //   name:'数据展示',
      //   key:'view'
      // },{
      //   name:'打印模板',
      //   key:'print'
      // },{
      //   name:'高级选项',
      //   key:'config'
      // },
      {
        icon: 'richangbaoji01',
        name: '表单测试',
        key: 'test',
      }, {
        icon: 'save',
        name: '保存',
        right: true,
        key: 'save',
      }];
      return items;
    },
  },
  mounted() {
    this.getData();
    this.getFormList();
  },
  watch: {
    option: {
      handler(v) {
        if (v && v.form) {
          this.form = cloneDeep(v.form);
        }
      },
      deeply: true,
      immediate: true,
    },
    value: {
      handler(v) {
        this.getData();
      },
      deeply: true,
      immediate: true,
    },
  },
  methods: {
    getFormList() {
      this.loadingList = true;
      this.$api.get('/forms').then((res)=>{
        this.items = res.data.data;
      }).finally((e)=>{
        this.loadingList=false;
      });
    },
    open() {
      this.getData();

      this.modalSelector=true; this.formView='editor';
    },
    getData() {
      if (this.value) {
        this.$api.get(`forms/${this.value}`).then((res)=>{
          this.form = res.data.data;
        });
      } else {
        if (this.option && this.option.form) {
          this.form = _.cloneDeep(this.option.form);
        } else {
          this.form = {id: 'create',
            name: '新建表单',
            fields: []};
        }
      }
    },
    handleSave() {
      this.$refs.editor.save();
      this.form.fields.forEach((v, i)=>{
        v.order = i+1;
      });
      if (this.form.id && this.form.id != 'create') {
        this.$api.patch(`/forms/${this.form.id}`, this.form).then((res)=>{
          this.value = this.form.id;
          this.$emit('input', this.form.id);
          this.$emit('save');
          this.modalSelector = false;
        });
      } else {
        this.$api.post(`/forms`, this.form).then((res)=>{
          const {id} = res.data.data;
          this.value = id;
          this.$emit('input', id);
          this.$emit('save');
          this.modalSelector = false;
        });
      }
    },
    handleEvent(e) {
      if (e == 'save') {
        this.handleSave();
      } else {
        this.formView = e;
        if (e == 'open' && this.items.length == 0) {
          this.getFormList();
        }
      }
    },
  },
};
</script>

<style lang="less">
.ugo-modal{
  .ivu-modal-body{
    padding:0;
  }
}
</style>
